/* Contraste sobre cor escolhida pelo lojista.
   A paleta da página de captura vem da configuração da empresa — três cores livres,
   sem garantia nenhuma. O texto que vai por cima delas não pode ser fixo: com
   #0a5c5a (o padrão) o branco dá 7,8:1 e passa; com #eb8fae (uma empresa real na
   base) dá 2,31:1 e reprova. A tinta se deriva da luminância, não se escolhe.
   Ver docs/designsystem/propostas/pagina-de-captura-publica.html §5. */

export const TINTA_ESCURA = '#151512';
export const TINTA_CLARA = '#ffffff';

/** Limiar em que a razão de 4,5:1 troca de lado entre tinta clara e escura. */
const LIMIAR = 0.179;

function canal(v: number): number {
  const c = v / 255;
  return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}

function rgb(hex: string): [number, number, number] | null {
  let h = (hex || '').trim().replace(/^#/, '');
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  return [
    parseInt(h.slice(0, 2), 16),
    parseInt(h.slice(2, 4), 16),
    parseInt(h.slice(4, 6), 16),
  ];
}

/** Luminância relativa (WCAG 2.x). Devolve null se o hex não for válido. */
export function luminanciaRelativa(hex: string): number | null {
  const c = rgb(hex);
  if (!c) return null;
  return 0.2126 * canal(c[0]) + 0.7152 * canal(c[1]) + 0.0722 * canal(c[2]);
}

/** Razão de contraste entre duas cores (1:1 a 21:1). */
export function razaoDeContraste(a: string, b: string): number | null {
  const la = luminanciaRelativa(a);
  const lb = luminanciaRelativa(b);
  if (la === null || lb === null) return null;
  const [claro, escuro] = la > lb ? [la, lb] : [lb, la];
  return (claro + 0.05) / (escuro + 0.05);
}

/** A tinta que fica legível sobre `fundo`. Hex inválido cai no branco, como era antes. */
export function tintaSobre(fundo: string): string {
  const l = luminanciaRelativa(fundo);
  if (l === null) return TINTA_CLARA;
  return l > LIMIAR ? TINTA_ESCURA : TINTA_CLARA;
}
